import { Link } from "react-router-dom";
import { Instagram, Mail, Phone } from "lucide-react";
import Logo from "@/components/Logo";
import { Overline } from "@/components/Motion";
import { useSettings, usePage } from "@/settings";

export default function Footer() {
  const s = useSettings();
  const g = usePage("global");
  return (
    <footer data-testid="site-footer" className="bg-ink text-paper mt-0">
      <div className="px-6 md:px-12 pt-20 pb-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo dark />
            <p className="mt-6 font-display italic text-xl text-paper/70 max-w-sm leading-relaxed">
              {s.hero_line_1} {s.hero_line_2}
            </p>
          </div>
          <div className="md:col-span-3">
            <Overline dark>Explore</Overline>
            <ul className="mt-5 space-y-3 font-mono text-xs uppercase tracking-[0.2em] text-paper/60">
              <li><Link className="hover:text-brand transition-colors" to="/work/architecture">Architecture</Link></li>
              <li><Link className="hover:text-brand transition-colors" to="/work/art">Art</Link></li>
              <li><Link className="hover:text-brand transition-colors" to="/services">Services</Link></li>
              <li><Link className="hover:text-brand transition-colors" to="/workshops">Workshops</Link></li>
              <li><Link className="hover:text-brand transition-colors" to="/shop">Shop</Link></li>
              <li><Link className="hover:text-brand transition-colors" to="/careers">Careers</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <Overline dark>Studio</Overline>
            <ul className="mt-5 space-y-3 text-sm text-paper/60">
              <li className="flex items-center gap-3"><Mail size={14} className="text-brand" /> {s.contact_email}</li>
              <li className="flex items-center gap-3"><Phone size={14} className="text-brand" /> {s.contact_phone}</li>
              <li className="flex items-center gap-3"><Instagram size={14} className="text-brand" /> {s.contact_instagram}</li>
              <li className="pt-2 text-paper/40">{s.contact_location}</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-paper/10">
        <div className="px-6 md:px-12 py-6 max-w-7xl mx-auto flex flex-col sm:flex-row justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.25em] text-paper/35">
          <span>{g.footer_copyright || "© 2026 IKSHA — Art + Architecture"}</span>
          <span className="inline-flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-brand inline-block" />
            {g.footer_note || "Made with material & intent"}
          </span>
        </div>
      </div>
    </footer>
  );
}
